export default "__VITE_ASSET__5cb066f4__"